import styled from 'styled-components'

export const EmptyWrapper = styled.div`
  position: relative;
  flex: 1;

  display: flex;
  align-items: center;
  justify-content: center;
`
